<template>
  <ODialog ref="dialog" :maxWidth="400" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Duplicar ScreenSet" @close="dismiss" />

      <v-card-text class="pa-6">
        <p>
          Informe um novo nome (e, se necessário, um novo código) para a cópia
          do ScreenSet selecionado.
        </p>
        <v-text-field v-model="row.name" hide-details label="Nome" />
        <ODecHexInput
          class="mt-4"
          format="hex"
          v-model="row.code"
          hide-details
          label="Código (hex)"
        />
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        @cancel="dismiss"
        @apply="apply"
        txtApply="Duplicar"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { ScreenSet } from '@/models'

export default {
  components: {
    ODecHexInput: require('oderon-vue/cpts/ODecHexInput').default
  },
  data() {
    return { id: null, row: null }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      this.row = await ScreenSet.findById(this.id)
      delete this.row.id
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    apply() {
      this.$refs.dialog.$apply(this.row)
    }
  }
}
</script>

<style></style>
